import React from "react";
import useWindowSize from "./useWindowSize";


const breakpoint = 1023;

export default function useIsMobile() {
  const [windowWidth] = useWindowSize()
  const [isMobile, setIsMobile] = React.useState(windowWidth <= breakpoint-1)
  React.useEffect(() => {
      setIsMobile(windowWidth <= breakpoint-1)
  }, [windowWidth])
  return isMobile
}